import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/login/login-page.component').then(
            (c) => c.LoginPageComponent,
          ),
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('./pages/sign-up/sign-up-page.component').then(
            (c) => c.SignUpPageComponent,
          ),
      },
      {
        path: 'update-password',
        loadComponent: () =>
          import('./pages/update-password/update-password-page.component').then(
            (c) => c.UpdatePasswordPageComponent,
          ),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/forgot-password/forgot-password-page.component').then(
            (c) => c.ForgotPasswordPageComponent,
          ),
      },
      {
        path: 'resend-sign-up-confirmation',
        loadComponent: () =>
          import(
            './pages/resend-sign-up-confirmation/resend-sign-up-confirmation-page.component'
          ).then((c) => c.ResendSignUpConfirmationPageComponent),
      },
      {
        path: 'setup-account',
        loadComponent: () =>
          import('./pages/setup-account/setup-account-page.component').then(
            (c) => c.SetupAccountPageComponent,
          ),
      },
    ],
  },
];
